import styles from "../../styles/components/mypage/homeMarketPc.module.css";
import { useRouter } from "next/router";

export default function HomeMarketPc({
  marketRows, // 부모가 계산해서 보낸 마켓 줄 데이터 [ [6개], [6개] ]
  hotdealRows, // 부모가 계산해서 보낸 핫딜 줄 데이터
  marketPage, // 현재 마켓 페이지 번호
  setMarketPage, // 마켓 페이지 변경 함수
  totalMarketPages, // 마켓 총 페이지 수
  hotDealPage, // 현재 핫딜 페이지 번호
  setHotDealPage, // 핫딜 페이지 변경 함수
  totalHotDealPages, // 핫딜 총 페이지 수
  activeTabChild,
  setActiveTabChild,
}) {
  const router = useRouter();

  // 현재 활성화된 탭에 따른 변수들 (화살표 로직용)
  const isMarket = activeTabChild === "market";
  const currentPage = isMarket ? marketPage : hotDealPage;
  const totalPages = isMarket ? totalMarketPages : totalHotDealPages;
  const setCurrentPage = isMarket ? setMarketPage : setHotDealPage;

  return (
    <>
      <div className={styles.homeMarket}>
        <div className={styles.homeMarketTitle}>
          <div className={styles.homeMarketTitle_Contents}>
            {/* 왼쪽 탭 영역 */}
            <div className={styles.homeMarketTitleLe_Tab}>
              {/* 첫 번째 탭: 마켓플레이스 */}
              <div
                className={styles.menuTabOption}
                onClick={() => setActiveTabChild("market")} // 클릭 시 상태를 "market"으로 변경
                style={{ cursor: "pointer" }} // 마우스 포인터 모양 변경
              >
                <div className={styles.menuTabOption_Contents}>
                  <div
                    className={`${
                      activeTabChild === "market"
                        ? styles.menuTabOption_Text
                        : styles.menuTabOption_Basic
                    } body2`}
                  >
                    마켓플레이스
                  </div>
                </div>
                <div className={styles.menuTabOption_Line}></div>
              </div>

              {/* 두 번째 탭: 핫딜 */}
              <div
                className={styles.menuTabOption}
                onClick={() => setActiveTabChild("hotdeal")} // 클릭 시 상태를 "hotdeal"으로 변경
                style={{ cursor: "pointer" }} // 마우스 포인터 모양 변경
              >
                <div className={styles.menuTabOption_Contents}>
                  <div
                    className={`${
                      activeTabChild === "hotdeal"
                        ? styles.menuTabOption_Text
                        : styles.menuTabOption_Basic
                    } body2`}
                  >
                    핫딜
                  </div>
                </div>
              </div>
            </div>

            {/* 오른쪽 화살표 영역 */}
            <div className={styles.homeMarketTitleRi_Arrow}>
              <div
                className={styles.buttonArrow_Contents}
                onClick={() =>
                  currentPage > 1 && setCurrentPage(currentPage - 1)
                }
                style={{ cursor: currentPage > 1 ? "pointer" : "default" }}
              >
                <div className={styles.buttonArrow}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M13.3839 4.11612C12.8957 3.62796 12.1045 3.62796 11.6163 4.11612L6.61631 9.11612C6.38188 9.35054 6.25009 9.66839 6.25009 9.99991C6.25009 10.3314 6.38188 10.6493 6.61631 10.8837L11.6163 15.8837C12.1045 16.3719 12.8957 16.3719 13.3839 15.8837C13.872 15.3955 13.872 14.6043 13.3839 14.1161L9.26767 9.99991L13.3839 5.88369C13.872 5.39554 13.872 4.60427 13.3839 4.11612Z"
                      fill={currentPage === 1 ? "#E3E8EC" : "#2F2F2F"}
                    />
                  </svg>
                </div>
              </div>

              <div
                className={styles.buttonArrow_Contents}
                onClick={() =>
                  currentPage < totalPages && setCurrentPage(currentPage + 1)
                }
                style={{
                  cursor: currentPage < totalPages ? "pointer" : "default",
                }}
              >
                <div className={styles.buttonArrow}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M6.61612 4.11612C7.10427 3.62796 7.89554 3.62796 8.38369 4.11612L13.3837 9.11612C13.6181 9.35054 13.7499 9.66839 13.7499 9.99991C13.7499 10.3314 13.6181 10.6493 13.3837 10.8837L8.38369 15.8837C7.89554 16.3719 7.10427 16.3719 6.61612 15.8837C6.12796 15.3955 6.12796 14.6043 6.61612 14.1161L10.7323 9.99991L6.61612 5.88369C6.12796 5.39554 6.12796 4.60427 6.61612 4.11612Z"
                      fill={currentPage >= totalPages ? "#E3E8EC" : "#2F2F2F"}
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div className={styles.homeMarketSe_Group}>
            {/* --- 섹션 1: 마켓플레이스 전용 반복문 --- */}
            {activeTabChild === "market" &&
              marketRows.map((group, gIdx) => (
                <div
                  key={`market-row-${gIdx}`}
                  className={styles.homeMarketSeRe_Repeat}
                >
                  {group.map((item, iIdx) => (
                    <div
                      key={item.id || iIdx}
                      className={styles.homeCard}
                      onClick={() =>
                        router.push(`/parts/inventory/${item.it_id}`)
                      }
                      style={{ cursor: "pointer" }} // 마우스 포인터 모양 변경
                    >
                      {/* 이미지 영역 */}
                      <div
                        className={
                          item?.it_img1?.trim() &&
                          item?.it_img1.startsWith("https")
                            ? styles.homeCardFi_image
                            : styles.homeCardFi_Noimage
                        }
                      >
                        {item?.it_img1?.trim() &&
                        item?.it_img1.startsWith("https") ? (
                          <img
                            src={item.it_img1}
                            className={styles.image}
                            alt="상품"
                            onError={(e) => {
                              e.target.src = "/images/noimageKO.jpg";
                            }}
                          />
                        ) : (
                          <img
                            src="/images/noimageKO.jpg"
                            className={styles.image}
                            alt="상품"
                          />
                        )}
                        <div className={styles.labelHomeBlack}>
                          {/* SVG 생략 (기존 것 유지) */}
                          <div
                            className={`${styles.labelHome_Text_White} label2`}
                          >
                            견적요청
                          </div>
                        </div>
                      </div>
                      {/* 정보 영역 */}
                      <div className={styles.homeCardSe_Info}>
                        <div className={styles.homeCardSeFi_ItemInfo}>
                          <div
                            className={`${styles.homeCardSeFiFi_Name} body3`}
                          >
                            {item.it_name}
                          </div>
                          <div
                            className={`${styles.homeCardSeFiSe_Maker} caption2`}
                          >
                            {item.it_brand}
                          </div>
                          <div className={styles.homeCardSeFiTh_tag}>
                            <div className={styles.labelHome}>
                              <div
                                className={`${styles.labelHome_Text} label2`}
                              >
                                특가제공
                              </div>
                            </div>
                            <div className={styles.labelHomeGray}>
                              <div
                                className={`${styles.labelHome_Text_Gray} label2`}
                              >
                                바로출고
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.homeCardSeSe_Inventory}>
                          {/* 재고 아이콘 SVG 생략 */}
                          <div className={styles.homeCardSeSeRi_TextGroup}>
                            <div
                              className={`${styles.homeCardSeSeRiLe_Num} body3`}
                            >
                              {Number(item.it_stock_qty).toLocaleString()}
                            </div>
                            <div
                              className={`${styles.homeCardSeSeRiRi_Unit} caption2`}
                            >
                              개
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {/* 빈 공간 채우기 */}
                  {group.length < 6 &&
                    Array.from({ length: 6 - group.length }).map((_, index) => (
                      <div
                        className={styles.homeCard}
                        style={{ visibility: "hidden" }}
                      >
                        <div className={styles.homeCardFi_image}>
                          <img
                            src={"/images/noimageKO.jpg"}
                            className={styles.image}
                            alt="핫딜"
                          />
                          <div className={styles.labelHomeRed}>
                            <div
                              className={`${styles.labelHome_Text_White} label2`}
                            ></div>
                          </div>
                        </div>
                        <div className={styles.homeCardSe_Info}>
                          <div className={styles.homeCardSeFi_ItemInfo}>
                            <div
                              className={`${styles.homeCardSeFiFi_Name} body3`}
                            ></div>
                            <div
                              className={`${styles.homeCardSeFiSe_Maker} caption2`}
                            ></div>
                            <div
                              className={`${styles.homeCardSeFiTh_Price} caption2`}
                            ></div>
                          </div>
                          <div className={styles.homeCardSeSe_Inventory}>
                            {/* 핫딜용 재고/단가 SVG 생략 */}
                            <div className={styles.homeCardSeSeRi_TextGroup}>
                              <div
                                className={`${styles.homeCardSeSeRiLe_Num} body3`}
                              ></div>
                              <div
                                className={`${styles.homeCardSeSeRiRi_Unit} caption2`}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ))}

            {/* --- 섹션 2: 핫딜 전용 반복문 --- */}
            {activeTabChild === "hotdeal" &&
              hotdealRows.map((group, gIdx) => (
                <div
                  key={`hotdeal-row-${gIdx}`}
                  className={styles.homeMarketSeRe_Repeat}
                >
                  {group.map((item, iIdx) => (
                    <div
                      key={item.id || iIdx}
                      className={styles.homeCard}
                      onClick={() =>
                        router.push(`/parts/mallview/${item.it_id}`)
                      }
                      style={{ cursor: "pointer" }} // 마우스 포인터 모양 변경
                    >
                    <div                         className={
                          item?.it_img1?.trim() &&
                          item?.it_img1.startsWith("https")
                            ? styles.homeCardFi_image
                            : styles.homeCardFi_Noimage
                        }>
                                                {item?.it_img1?.trim() &&
                        item?.it_img1.startsWith("https") ? (
                          <img
                            src={item.it_img1}
                            className={styles.image}
                            alt="핫딜"
                            onError={(e) => {
                              e.target.src = "/images/noimageKO.jpg";
                            }}
                          />
                        ) : (
                          <img
                            src="/images/noimageKO.jpg"
                            className={styles.image}
                            alt="핫딜"
                          />
                        )}
                        <div className={styles.labelHomeRed}>
                          <div
                            className={`${styles.labelHome_Text_White} label2`}
                          >
                            구매하기
                          </div>
                        </div>
                      </div>
                      <div className={styles.homeCardSe_Info}>
                        <div className={styles.homeCardSeFi_ItemInfo}>
                          <div
                            className={`${styles.homeCardSeFiFi_Name} body3`}
                          >
                            {item.it_name}
                          </div>
                          <div
                            className={`${styles.homeCardSeFiSe_Maker} caption2`}
                          >
                            {item.it_brand}
                          </div>
                          <div
                            className={`${styles.homeCardSeFiTh_Price} caption2`}
                          >
                            {Number(item.it_price_before).toLocaleString()}원
                          </div>
                        </div>
                        <div className={styles.homeCardSeSe_Inventory}>
                          {/* 핫딜용 재고/단가 SVG 생략 */}
                          <div className={styles.homeCardSeSeRi_TextGroup}>
                            <div
                              className={`${styles.homeCardSeSeRiLe_Num} body3`}
                            >
                              {Number(item.it_price).toLocaleString()}
                            </div>
                            <div
                              className={`${styles.homeCardSeSeRiRi_Unit} caption2`}
                            >
                              원
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {/* 빈 공간 채우기 */}
                  {group.length < 6 &&
                    Array.from({ length: 6 - group.length }).map((_, index) => (
                      <div
                        className={styles.homeCard}
                        style={{ visibility: "hidden" }}
                      >
                        <div className={styles.homeCardFi_image}>
                          <img
                            src={"/images/noimageKO.jpg"}
                            className={styles.image}
                            alt="핫딜"
                          />
                          <div className={styles.labelHomeRed}>
                            <div
                              className={`${styles.labelHome_Text_White} label2`}
                            ></div>
                          </div>
                        </div>
                        <div className={styles.homeCardSe_Info}>
                          <div className={styles.homeCardSeFi_ItemInfo}>
                            <div
                              className={`${styles.homeCardSeFiFi_Name} body3`}
                            ></div>
                            <div
                              className={`${styles.homeCardSeFiSe_Maker} caption2`}
                            ></div>
                            <div
                              className={`${styles.homeCardSeFiTh_Price} caption2`}
                            ></div>
                          </div>
                          <div className={styles.homeCardSeSe_Inventory}>
                            {/* 핫딜용 재고/단가 SVG 생략 */}
                            <div className={styles.homeCardSeSeRi_TextGroup}>
                              <div
                                className={`${styles.homeCardSeSeRiLe_Num} body3`}
                              ></div>
                              <div
                                className={`${styles.homeCardSeSeRiRi_Unit} caption2`}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ))}
          </div>
        
      </div>
    </>
  );
}
